// @ts-expect-error
import ENV from 'receivable-invoices-js/config/environment';

type FetchApiOptions = Omit<RequestInit, 'headers'> & {
  headers?: Record<string, string>;
};

export async function fetchApi(
  url: string | URL,
  options: FetchApiOptions = {}
): Promise<Response> {
  const headers: Record<string, string> = { ...(options.headers || {}) };

  if (typeof ENV !== 'undefined' && ENV.deployTarget === 'staging' && ENV.stagingAccessToken) {
    headers['X-Qonto-Staging-Token'] = ENV.stagingAccessToken;
  }

  const response = await fetch(url.toString(), {
    ...options,
    headers,
  });

  return response;
}
